import React from 'react';
import './animate6.less';

const Animate6: React.FC = () => {
    return (
        <div className="c-animate6">
            <div className="bg-1"></div>
            <div className="bg-2"></div>
            <div className="bg-3"></div>
        </div>
    );
};

export default Animate6;
